import React from 'react';
import { IconProps } from '.';

const SvgThreeBars = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M21 6.75H3v-1.5h18v1.5ZM21 12.75H3v-1.5h18v1.5ZM3 18.75h18v-1.5H3v1.5Z' />
    </svg>
  );
};

export default SvgThreeBars;
